import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  speakerTypes: null,
}
export const speakerTypesSlice = createSlice({
  name: 'speakerType',
  initialState,
  reducers: {
    setTypes: (state, action) => {
      state.speakerTypes = action.payload
    },
  },
})
// Selectors
export const getSpeakerTypesList = (state) => state.speakerType.speakerTypes

// Action creators are generated for each case reducer function
export const { setTypes } = speakerTypesSlice.actions

export default speakerTypesSlice.reducer
